/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { TrackingContextData } from 'js/lib/retracked';

import { FullscreenDialog } from '@coursera/cds-core';

import type { StaffManagementScopeData } from '../types/eventingTypes';
import UserRoleViewContainer from './UserRoleViewContainer';

interface Props {
  partnerId: string | number | undefined;
  eventData?: TrackingContextData;
  ingressPointScopeData?: StaffManagementScopeData;
}

export interface StaffPermissionsModalContextType {
  openModal: (userId: string | number) => void;
}

const StaffPermissionsModalContext = React.createContext<StaffPermissionsModalContextType>({
  openModal: () => undefined,
});

export const useModalContext = () => React.useContext(StaffPermissionsModalContext);

const WithUserRoleModal: React.LegacyFunctionComponentWithChildren<Props> = ({
  partnerId,
  children,
  eventData,
  ingressPointScopeData,
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [userId, setUserId] = React.useState<number | string>();

  const closeModal = () => {
    setUserId(undefined);
    setIsModalOpen(false);
  };

  const openModal = React.useCallback<(...args: $TSFixMe[]) => $TSFixMe>((id: number | string) => {
    setUserId(id);
    setIsModalOpen(true);
  }, []);

  return (
    <StaffPermissionsModalContext.Provider value={{ openModal }}>
      {children}
      <FullscreenDialog open={isModalOpen} onClose={closeModal}>
        <FullscreenDialog.Header />
        <UserRoleViewContainer
          partnerId={partnerId}
          userId={userId}
          eventData={eventData}
          ingressPointScopeData={ingressPointScopeData as StaffManagementScopeData}
        />
      </FullscreenDialog>
    </StaffPermissionsModalContext.Provider>
  );
};

export default WithUserRoleModal;
